export class SubCompanyCompensationPlanApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCompensationPlans({ subCompanyId }) {
    return this.#http.get(`/api/sub-companies/${subCompanyId}/compensation-plans`);
  }

  async createCompensationPlan({ subCompanyId, ...body }) {
    return this.#http.post(`/api/sub-companies/${subCompanyId}/compensation-plans`, body);
  }

  async updateCompensationPlan({ subCompanyId, planId, ...body }) {
    return this.#http.put(`/api/sub-companies/${subCompanyId}/compensation-plans/${planId}`, body);
  }

  async deleteCompensationPlan({ subCompanyId, planId }) {
    return this.#http.delete(`/api/sub-companies/${subCompanyId}/compensation-plans/${planId}`);
  }

  async approveChange({ subCompanyId, planId }) {
    return this.#http.post(
      `/api/sub-companies/${subCompanyId}/compensation-plans/${planId}/approve-change`,
    );
  }
}
